import { React } from "react";
import { Col, Row } from "reactstrap";
import { Selectform } from "../../components/drop_down/Selectform";
import {NoofQuestions, ExpandNoofQuestions, NoofOptions} from "../../components/constants/constants";
import { exerciseType } from "../../components/constants/constants";
export function ReadingSetting({
  formData,
  handleInputChange,
  IsGenerating,
  taskquestionType,
}) {
  let NO_OF_QUESTIONS = NoofQuestions;
  if(formData?.exercise_type === exerciseType.GRAMMAR_TASK || formData?.exercise_type === exerciseType.VOCABULARY_TASK )
  {
    NO_OF_QUESTIONS = ExpandNoofQuestions
  }
  return (
    <Row className="g-0">
      <Col className="col-12 sm-flex">
      {taskquestionType.length > 0 ? (
        <>
          <Col className="col-lg-6 col-sm-12 pe-3 ps-1 pt-3">
            <label class="pb-2 fw-600" for="question_type">
                Question type
            </label>
            <div class="form-group md-group show-label">
                <Selectform
                className="form-select custom-select-bold"
                name="question_type"
                placeholder={"Select question type"}
                selectedvalue={formData.question_type}
                choices={taskquestionType}
                onChange={handleInputChange}
                disabled={IsGenerating}
                required
                />
            </div>
          </Col>
          <Col className="col-lg-6 col-sm-12 pe-3 ps-1 pt-3">
            <label class="pb-2 fw-600" for="questions">
              Number of questions
            </label>
            <div class="form-group md-group show-label">
              <Selectform
                className="form-select custom-select-bold"
                name="questions"
                placeholder={"Select questions*"}
                selectedvalue={formData.questions}
                choices={NO_OF_QUESTIONS}
                onChange={handleInputChange}
                disabled={IsGenerating}
                required
              />
            </div>
          </Col>
        </>
      ):(
        <>
          <Col className="col-lg-6 col-sm-12 pe-3 ps-1 pt-3">
            <label class="pb-2 fw-600" for="questions">
              Number of questions
            </label>
            <div class="form-group md-group show-label">
              <Selectform
                className="form-select custom-select-bold"
                name="questions"
                placeholder={"Select questions*"}
                selectedvalue={formData.questions}
                choices={NO_OF_QUESTIONS}
                onChange={handleInputChange}
                disabled={IsGenerating}
                required
              />
            </div>
          </Col>
          <Col className="col-lg-6 col-sm-12 pe-3 ps-1 pt-3">
            {formData?.question_type && formData?.question_type !== "Fill in the blank" &&
                formData?.question_type !== "Drag and drop" ? (
              <Col className="col-12 pe-3 ps-1 pt-3">
                <label class="pb-2 fw-600" for="options">
                Options per question
                </label>
                <div class="form-group md-group show-label">
                  <Selectform
                    className="form-select custom-select-bold"
                    name="options"
                    placeholder={"Select options"}
                    selectedvalue={formData.options}
                    choices={NoofOptions}
                    onChange={handleInputChange}
                    disabled={IsGenerating}
                    required
                  />
                </div>
              </Col>
              ):null}
          </Col>
        </>
      )}
      </Col>
      <Col className="pb-3">
        <Col className="col-12 sm-flex">
        {taskquestionType.length > 0 && formData?.question_type && formData?.question_type !== "Fill in the blank" &&
                formData?.question_type !== "Drag and drop" ? (
          <Col className="col-12 pe-3 ps-1 pt-3">
            <label class="pb-2 fw-600" for="options">
            Options per question
            </label>
            <div class="form-group md-group show-label">
              <Selectform
                className="form-select custom-select-bold"
                name="options"
                placeholder={"Select options"}
                selectedvalue={formData.options}
                choices={NoofOptions}
                onChange={handleInputChange}
                disabled={IsGenerating}
                required
              />
            </div>
          </Col>
          ):null}
        </Col>
      </Col>
    </Row>
  );
}
